module.exports = __webpack_public_path__ + "img/Funk_Feststation_digital.a2315b06.svg";